/* eslint-disable import/no-unused-modules */

import EVENTS from "../constants/events";
import generateEventPair from "../helpers/generateEventPair";

export const {
  dispatcher: dispatchListingRemoved,
  responder: respondToListingRemoved
} = generateEventPair({
  eventName: EVENTS.LISTING_REMOVED,
  signatureParams: ["listingId", "listingType"]
});
